import { Link } from 'react-router-dom'

const SURFACES = [
  { to: '/board', title: 'Wall board', body: 'The always-on tablet display. Prayer times, chores, who is in, the queue.' },
  { to: '/plan', title: 'Floor planner', body: 'Draw the office. Desktop only — editing needs a keyboard and a pointer.' },
  { to: '/app', title: 'Phone', body: 'Chores, decisions, money and the queue, from anywhere.' },
  { to: '/settings', title: 'Settings', body: 'Qibla mode, the purchase threshold, the office day, and backups.' },
]

export function Home() {
  return (
    <main style={{ maxWidth: 860, margin: '0 auto', padding: '64px 24px' }}>
      <p className="pill">Office OS</p>
      <h1 style={{ fontSize: 40, marginTop: 14 }}>Three surfaces, one system</h1>
      <p className="muted" style={{ fontSize: 18, maxWidth: 620 }}>
        The same data everywhere, stored locally on every device so the office keeps
        working when the internet does not.
      </p>
      <div className="stack gap-3" style={{ marginTop: 34 }}>
        {SURFACES.map(s => (
          <Link key={s.to} to={s.to} className="card" style={{ textDecoration: 'none', color: 'inherit' }}>
            <h2 style={{ fontSize: 21 }}>{s.title}</h2>
            <p className="muted" style={{ margin: '6px 0 0' }}>{s.body}</p>
          </Link>
        ))}
      </div>
    </main>
  )
}
